// the title of the workbench (shows up in the <title> and nav bar)
export const APP_TITLE = "Mapping.ml";
// the "blocking_task" type for this workbench
export const TASK_KIND = "mapping";
// the "input" xml job content role
export const INPUT_ROLE = "mapping-predicted-xml";
// the "output" xml job content role
export const OUTPUT_ROLE = "mapping-reviewed-xml";
